import { LightningElement, api } from 'lwc';

export default class spinnerComponent extends LightningElement {
    static renderMode = 'light';
    @api spinnerStyle = null;

    @api 
    set size(value) {
        this._size = value || 'medium';
    }
    get size() {
        return this._size;
    }

    get spinnerClass() {
        console.log('in spinner class');
        switch(this.size) {
            case 'small':
                return 'slds-spinner slds-spinner_small';
            case 'medium':
                return 'slds-spinner slds-spinner_medium';
            case 'large':
                return 'slds-spinner slds-spinner_large';
            default:
                return 'slds-spinner slds-spinner_medium';
        }
    }

}